import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data || {})).catch(() => setContent({}));
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}
